import React from "react";
import { MapPin, Phone, Mail, Clock, MessageCircle } from "lucide-react";
import { useSettings, waLink, telLink } from "../context/SettingsContext";
import { Reveal } from "../components/ui";
import { PageHero } from "./About";
import LeadForm from "../components/LeadForm";
import SEO from "../components/SEO";

export default function Contact() {
  const { settings } = useSettings();
  const items = [
    [MapPin, "Office Address", settings.address, settings.google_maps_url],
    [Phone, "Phone", settings.phone, telLink(settings.phone)],
    [MessageCircle, "WhatsApp", "Chat with us", waLink(settings.whatsapp, `Hello ${settings.company_name}, I would like to discuss my project.`)],
    [Mail, "Email", settings.email, `mailto:${settings.email}`],
    [Clock, "Business Hours", settings.business_hours, null],
  ];

  return (
    <>
      <SEO title="Contact Us" description="Contact GNONS Design & Construction, Indore." />
      <PageHero kicker="Contact Us" title="Let's Build Something Great" subtitle="Reach out for a free consultation." />

      <section className="py-16 md:py-20 bg-white">
        <div className="container-x grid lg:grid-cols-2 gap-8 lg:gap-10 items-start">
          <Reveal>
            <h2 className="text-2xl font-bold text-ink mb-6">Get in Touch</h2>
            <div className="space-y-5">
              {items.map(([Icon, label, val, href], i) => (
                <div key={i} className="flex gap-4">
                  <div className="w-11 h-11 rounded-full bg-beige flex items-center justify-center shrink-0"><Icon size={20} className="text-gold" /></div>
                  <div>
                    <div className="text-xs uppercase tracking-wide text-muted font-semibold">{label}</div>
                    {href ? <a href={href} target="_blank" rel="noreferrer" className="text-ink font-medium hover:text-gold">{val}</a> : <div className="text-ink font-medium">{val}</div>}
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8 rounded-xl2 overflow-hidden border border-line aspect-[16/10]">
              <iframe title="GNONS Location" width="100%" height="100%" style={{ border: 0 }} loading="lazy"
                src="https://www.google.com/maps?q=Orbit+Mall+Vijay+Nagar+Indore&output=embed" />
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="rounded-xl2 border border-line bg-sand p-6 md:p-8">
              <h2 className="text-2xl font-bold text-ink mb-6">Send Us a Message</h2>
              <LeadForm sourcePage="Contact Page" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
